export default __webpack_public_path__ + "static/media/intro_image_logo.8bcfd771.jpeg";